import * as React from 'react';
import { SVGProps } from 'react';

const IconDropSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M.5 6.364C.5 3.636 4.077 0 4.077 0s1.185 1.205 2.191 2.747c-.33.627-.565 1.284-.565 1.881 0 1.252.789 2.234 1.868 2.543A3.533 3.533 0 0 1 4.077 10C2.102 10 .5 8.456.5 6.364Z" />
    <path d="M7.208 3.632c-.201.444-.28.781-.28 1.005 0 .778.557 1.334 1.286 1.334.73 0 1.286-.556 1.286-1.334 0-.224-.078-.561-.28-1.005a8.308 8.308 0 0 0-.76-1.294c-.082-.117-.165-.23-.246-.338-.08.108-.163.22-.246.338a8.308 8.308 0 0 0-.76 1.294Z" />
  </svg>
);
export default IconDropSizeXs;
